import api from '@/api/api';

const DOMAIN = '/company/auth';

const login = async ({
	cnpj,
	password,
}: {
	cnpj: string;
	password: string;
}): Promise<Companies.LoginResponse> => {
	const { data } = await api.post(`${DOMAIN}/login`, { cnpj, password });
	return data;
};

/** Copiado de `AdminService.getMeAdmin` / `ProfessionalsService.getMe`. */
const getMe = async (): Promise<Companies.Company> => {
	const { data } = await api.get(`${DOMAIN}/me`);
	return data;
};

/** Mesmo endpoint global do admin/user: `DELETE /auth/logout`. */
const logout = async (): Promise<void> => {
	await api.delete('/auth/logout');
};

const CompanyAuthService = {
	login,
	getMe,
	logout,
};

export { CompanyAuthService };
